import React from 'react'
import { NavLink } from 'react-router-dom'
import { tr } from 'i18n'
import { useRequestCounts } from '../RequestCountsContext'
import RequestCount from '../RequestCount/RequestCount.tsx'
import styles from '../WorkspaceLayout.module.scss'
import './WorkspaceNavigation.scss'

export default function WorkspaceNavigation({ items, mobile = false }) {
  const { total } = useRequestCounts()
  return <>{items.map(({ path, label, icon: Icon }) => {
    const requests = path === '/requests/'
    const description = requests ? `${tr('На рассмотрении')}: ${total ?? '—'}` : ''
    return <NavLink key={path} to={path} aria-label={`${tr(label)}${description ? ` · ${description}` : ''}`}
      title={`${tr(label)}${description ? ` · ${description}` : ''}`}
      className={({ isActive }) => `${styles.navItem} request-nav-link${mobile ? ' request-nav-link--mobile' : ''}${isActive ? ` ${styles.active}` : ''}`}>
      <Icon size={19} aria-hidden="true" /><span>{tr(label)}</span>
      {requests && <RequestCount count={total} />}
    </NavLink>
  })}</>
}
